import { createStore } from 'vuex'

export default createStore({
    state: {
        user: undefined,
        visit: undefined,
    },
    mutations: {
        saveUser(state, user) {
            state.user = user;
        },
        saveVisit(state, visit) {
            state.visit = visit;
        },
    },
    getters: {
        getUser(state) {
            return state.user;
        },
        getVisit(state) {
            return state.visit;
        },
        isGeneticAdmin(state) {
            for (var i = 0; i < state.user.roles.length; i++) {
                var role = state.user.roles[i];
                if (role.roletype == "999999") {
                    return true;
                }
            }
            if (state.visit.usertype.includes("99")) {
                return true;
            }
            return false;
        },
        isReviewer(state){
            for (var i = 0; i < state.user.roles.length; i++) {
                var role = state.user.roles[i];
                if (role.roletype == "999999"
                    || role.roletype == "21"
                    || role.roletype == "40") {
                    return true;
                }
            }
            return false;
        },
        isAdmin(state) {
            for (var i = 0; i < state.user.roles.length; i++) {
                var role = state.user.roles[i];
                if (role.roletype == "999999") {
                    return true;
                }
            }
            return false;
        },
        isGroupAdmin(state) {
            if (state.user.group.groupadmin == state.user.id){
                return true;
            }
        },
        isOther(state) {
            for (var i = 0; i < state.user.roles.length; i++) {
                var role = state.user.roles[i];
                if (role.roletype == "999999" || role.roletype == "09") {
                    return true;
                }
            }
            return false;
        },
        isCurrentUser: (state) => (id) => {
            if (state.user.id === id) {
                return true;
            }
            for (var i = 0; i < state.user.roles.length; i++) {
                var role = state.user.roles[i];
                if (role.roletype == "999999") {
                    return true;
                }
            }
            return false;
        },
        isCurrentUserByName: (state) => (name) => {
            if (state.user.name == name) {
                return true;
            }
            for (var i = 0; i < state.user.roles.length; i++) {
                var role = state.user.roles[i];
                if (role.roletype == "999999") {
                    return true;
                }
            }
            return false;
        },
    }
})